import { IIconBase } from '..'

const inscEstadualIcon = ({
  color = '#333752',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2878_7487)'>
        <rect width={width} height={height} fill='white' fillOpacity='0.01' />
        <path
          d='M8.59326 3.92004H3.40658C2.26658 3.92004 1.33325 4.85337 1.33325 5.99337V13.5667C1.33325 14.5334 2.02658 14.9467 2.87325 14.4734L5.49325 13.0134C5.77325 12.86 6.22659 12.86 6.49992 13.0134L9.11991 14.4734C9.96658 14.9467 10.6599 14.5334 10.6599 13.5667V5.99337C10.6666 4.85337 9.73326 3.92004 8.59326 3.92004Z'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.6666 5.99337V13.5667C10.6666 14.5334 9.97325 14.94 9.12659 14.4734L6.50659 13.0134C6.22659 12.86 5.77325 12.86 5.49325 13.0134L2.87325 14.4734C2.02658 14.94 1.33325 14.5334 1.33325 13.5667V5.99337C1.33325 4.85337 2.26658 3.92004 3.40658 3.92004H8.59326C9.73326 3.92004 10.6666 4.85337 10.6666 5.99337Z'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.6666 3.4067V10.98C14.6666 11.9467 13.9733 12.3534 13.1266 11.8867L10.6666 10.5134V5.99337C10.6666 4.85337 9.73326 3.92004 8.59326 3.92004H5.33325V3.4067C5.33325 2.2667 6.26658 1.33337 7.40658 1.33337H12.5933C13.7333 1.33337 14.6666 2.2667 14.6666 3.4067Z'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2878_7487'>
          <rect width={width} height={height} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default inscEstadualIcon
